import { ApiRequestConfig, apiService } from './api.service';

import { ICategory, ICategoryDto } from '@/interfaces/entities/category';
import { IApiService } from '@/interfaces/services/IApiService';

class CategoryService {
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async getAllCategories(pageNumber: number, config?: ApiRequestConfig) {
		return await this.api.get<{ data: ICategory[]; pageCount: number }>(
			`/category?page[number]=${pageNumber}&sort[name]=ASC`,
			config,
		);
	}

	async deleteCategory(id: number) {
		return await this.api.delete(`/category/${id}`);
	}

	async editCategory(id: number, category: ICategoryDto) {
		return await this.api.patch(`/category/${id}`, category);
	}

	async newCategory(category: ICategoryDto) {
		return await this.api.post(`/category`, category);
	}
}

export const categoryService = new CategoryService(apiService);
